import * as Types from '../../__generated__/api/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { ActionFragmentDoc } from './actions';
import { DestinationFragmentDoc } from './destination';
export type ButtonFragment = {
  __typename: 'Button';
  title: string;
  dsType: Types.DsButtonType;
  iconUrl: string | null;
  activeIconUrl: string | null;
  imageUrl: string | null;
  activeImageUrl: string | null;
  isIconAnimated: boolean | null;
  backgroundColor: string | null;
  textColor: string | null;
  focusedBackgroundColor: string | null;
  focusedTextColor: string | null;
  backgroundOpacityInPct: number | null;
  focusedBackgroundOpacityInPct: number | null;
  toggleTitle: string | null;
  toggleDsType: Types.DsButtonType | null;
  toggleIconUrl: string | null;
  toggleActiveIconUrl: string | null;
  toggleImageUrl: string | null;
  toggleActiveImageUrl: string | null;
  toggleIsIconAnimated: boolean | null;
  action: {
    __typename: 'Action';
    serverAction: { __typename: 'ServerAction'; payload: string } | null;
    tracking: {
      __typename: 'Tracking';
      identifier: string;
      details: Types.Scalars['Map']['output'];
    } | null;
    clientAction:
      | {
          __typename: 'DestinationClientAction';
          destination: {
            __typename: 'Destination';
            icid: Types.Scalars['Map']['output'] | null;
            externalId: string;
            path: string;
            type: Types.DestinationType;
          };
        }
      | { __typename: 'DisplayCastMenuAction'; actionName: string }
      | { __typename: 'DisplayPageModalAction'; path: string }
      | { __typename: 'IgnoreClientAction'; actionName: string }
      | { __typename: 'OpenEntitlementClientAction'; primaryId: string }
      | { __typename: 'OpenNotificationSettingsClientAction' }
      | { __typename: 'OpenPrivacySettingsClientAction' }
      | { __typename: 'OpenTechnicalInformationClientAction' }
      | { __typename: 'PartnerLinkClientAction'; actionName: string; url: string }
      | { __typename: 'ReloadClientAction'; actionName: string }
      | { __typename: 'ShowActionsModalClientAction'; actionName: string }
      | { __typename: 'SignOutClientAction' }
      | {
          __typename: 'ToggleButtonAction';
          actionName: string;
          reloadDelayInMs: number | null;
          shouldReloadClient: boolean;
        };
  };
  toggleAction: {
    __typename: 'Action';
    serverAction: { __typename: 'ServerAction'; payload: string } | null;
    tracking: {
      __typename: 'Tracking';
      identifier: string;
      details: Types.Scalars['Map']['output'];
    } | null;
    clientAction:
      | {
          __typename: 'DestinationClientAction';
          destination: {
            __typename: 'Destination';
            icid: Types.Scalars['Map']['output'] | null;
            externalId: string;
            path: string;
            type: Types.DestinationType;
          };
        }
      | { __typename: 'DisplayCastMenuAction'; actionName: string }
      | { __typename: 'DisplayPageModalAction'; path: string }
      | { __typename: 'IgnoreClientAction'; actionName: string }
      | { __typename: 'OpenEntitlementClientAction'; primaryId: string }
      | { __typename: 'OpenNotificationSettingsClientAction' }
      | { __typename: 'OpenPrivacySettingsClientAction' }
      | { __typename: 'OpenTechnicalInformationClientAction' }
      | { __typename: 'PartnerLinkClientAction'; actionName: string; url: string }
      | { __typename: 'ReloadClientAction'; actionName: string }
      | { __typename: 'ShowActionsModalClientAction'; actionName: string }
      | { __typename: 'SignOutClientAction' }
      | {
          __typename: 'ToggleButtonAction';
          actionName: string;
          reloadDelayInMs: number | null;
          shouldReloadClient: boolean;
        };
  } | null;
  toggleToolTip: {
    __typename: 'ToolTip';
    text: string;
    textColor: string;
    backgroundColor: string;
  } | null;
};

export const ButtonFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ButtonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Button' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActionFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dsType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activeIconUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activeImageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIconAnimated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'backgroundColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'focusedBackgroundColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'focusedTextColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'backgroundOpacityInPct' } },
          { kind: 'Field', name: { kind: 'Name', value: 'focusedBackgroundOpacityInPct' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'toggleAction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActionFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'toggleTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toggleDsType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toggleIconUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toggleActiveIconUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toggleImageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toggleActiveImageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toggleIsIconAnimated' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'toggleToolTip' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'textColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backgroundColor' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ButtonFragment, unknown>;
